import React from 'react';

import PropTypes from 'prop-types';

import EditableContainer from './editable-container';
import messages from './messages';
import ReadOnlyContainer from './read-only-container';
import ReturnCounter from './return-counter';
import { OrderDetailsSectionId } from '../../../fulfillment-plan/order-details-expanded-section-provider';
import ExpanderSection from '../../../tab-section/expander-section/expander-section';
import SectionTitle from '../../../tab-section/title';

import style from './shipment-details.module.less';

const ShipmentDetails = ({ returnFulfillmentId, counter, isEditable }) => {
  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.sectionAriaLabel}
      contentClassName={style['shipment-details-section-content']}
      headerContent={
        <div className={style['header-container']}>
          <SectionTitle messageDescriptor={messages.sectionTitle} />
          {!isEditable && <ReturnCounter counter={counter} />}
        </div>
      }
      sectionContent={isEditable ? <EditableContainer /> : <ReadOnlyContainer returnFulfillmentId={returnFulfillmentId} />}
      sectionId={OrderDetailsSectionId.ShipmentDetails}
    />
  );
};

export default ShipmentDetails;

ShipmentDetails.propTypes = {
  returnFulfillmentId: PropTypes.string.isRequired,
  counter: PropTypes.number.isRequired,
  isEditable: PropTypes.bool.isRequired,
};
